import {
  ConsentPolicyManagerInterface,
  ConsentPolicy,
  ConsentPolicyManagerConfig,
  PolicyErrorCallback,
  PolicySuccessCallback,
} from '..';
import { APP_DEF_ID } from './consts';
import { isWix } from './utils';

export function createPolicyInstance(consentPolicyInstance: ConsentPolicyManagerInterface) {
  (function () {
    const functionKeys: string[] = [
      'getCurrentConsentPolicy',
      'resetPolicy',
      '_getConsentPolicyHeader',
      'publishPolicyUpdateRequestedEvent',
    ];
    const dataKeys: string[] = ['initRan', 'hostname'];
    const publicAPI: Record<string, any> = {};

    functionKeys.forEach((key) => {
      publicAPI[key] = function () {
        // @ts-expect-error
        return consentPolicyInstance[key].apply(
          consentPolicyInstance,
          Array.from(arguments),
        );
      };
    });

    dataKeys.forEach((key) => {
      Object.defineProperty(publicAPI, key, {
        // @ts-expect-error
        get: () => consentPolicyInstance[key],
        set: (value) => {
          if (key === 'hostname') {
            consentPolicyInstance[key] = value;
          }
        },
      });
    });

    let appTokenAccessor: () => Promise<string> | undefined;

    publicAPI.init = (
      options: ConsentPolicyManagerConfig | string,
      getAppToken?: () => Promise<string> | undefined,
    ) => {
      // @ts-expect-error
      appTokenAccessor = getAppToken || undefined;
      return consentPolicyInstance.init(options);
    };

    publicAPI.setConsentPolicy = async (
      newPolicy: ConsentPolicy,
      successCallback?: PolicySuccessCallback,
      errorCallback?: PolicyErrorCallback,
    ) => {
      let accessToken: string | undefined = '';
      if (typeof appTokenAccessor === 'function') {
        try {
          accessToken = await appTokenAccessor();
        } catch (e) {
          accessToken = localAccessToken();
        }
      } else {
        accessToken = localAccessToken();
      }
      return consentPolicyInstance.setConsentPolicy(
        newPolicy,
        successCallback,
        errorCallback,
        accessToken,
      );
    };

    function localAccessToken(): string | undefined {
      const embedsAPI = (window as any).wixEmbedsAPI;
      return (
        !isWix() &&
        embedsAPI &&
        embedsAPI.getAppToken &&
        embedsAPI.getAppToken(APP_DEF_ID)
      );
    }

    Object.defineProperty(window as any, 'consentPolicyManager', {
      value: Object.freeze(publicAPI),
      writable: false,
      configurable: false,
      enumerable: true,
    });
  })();
}
